// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DispositiveProvisions_DispositiveProvisionFragment } from '../../graphql/DispositiveProvisions.fragments.generated';
import { gql } from '@apollo/client';
import { DispositiveProvisions_DispositiveProvisionFragmentDoc } from '../../graphql/DispositiveProvisions.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositiveProvisionTemplateData_DispositiveProvisionTemplateFragment = { __typename?: 'DispositiveProvisionTemplate', id: string, displayName: string, kind: Types.DispositiveProvisionTemplateKind, subKind: Types.DispositiveProvisionTemplateSubKind, proRata: boolean, residuaryPaysAllTaxes: boolean, document?: { __typename?: 'Document', id: string } | null, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', edges?: Array<{ __typename?: 'DispositiveProvisionEdge', node?: (
        { __typename?: 'DispositiveProvision' }
        & DispositiveProvisions_DispositiveProvisionFragment
      ) | null } | null> | null } };

export type DispositiveProvisionTemplateDataQueryVariables = Types.Exact<{
  templateWhere: Types.DispositiveProvisionTemplateWhereInput;
}>;


export type DispositiveProvisionTemplateDataQuery = { __typename?: 'Query', dispositiveProvisionTemplates: { __typename?: 'DispositiveProvisionTemplateConnection', edges?: Array<{ __typename?: 'DispositiveProvisionTemplateEdge', node?: (
        { __typename?: 'DispositiveProvisionTemplate' }
        & DispositiveProvisionTemplateData_DispositiveProvisionTemplateFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DispositiveProvisionTemplateData: 'DispositiveProvisionTemplateData' as const
  },
  Fragment: {
    DispositiveProvisionTemplateData_DispositiveProvisionTemplate: 'DispositiveProvisionTemplateData_DispositiveProvisionTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DispositiveProvisionTemplateData_DispositiveProvisionTemplateFragmentDoc = gql`
    fragment DispositiveProvisionTemplateData_DispositiveProvisionTemplate on DispositiveProvisionTemplate {
  id
  displayName
  document {
    id
  }
  kind
  subKind
  proRata
  residuaryPaysAllTaxes
  dispositiveProvisions {
    edges {
      node {
        ...DispositiveProvisions_DispositiveProvision
      }
    }
  }
}
    ${DispositiveProvisions_DispositiveProvisionFragmentDoc}`;
export const DispositiveProvisionTemplateDataDocument = gql`
    query DispositiveProvisionTemplateData($templateWhere: DispositiveProvisionTemplateWhereInput!) {
  dispositiveProvisionTemplates(where: $templateWhere) {
    edges {
      node {
        ...DispositiveProvisionTemplateData_DispositiveProvisionTemplate
      }
    }
  }
}
    ${DispositiveProvisionTemplateData_DispositiveProvisionTemplateFragmentDoc}`;

/**
 * __useDispositiveProvisionTemplateDataQuery__
 *
 * To run a query within a React component, call `useDispositiveProvisionTemplateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositiveProvisionTemplateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositiveProvisionTemplateDataQuery({
 *   variables: {
 *      templateWhere: // value for 'templateWhere'
 *   },
 * });
 */
export function useDispositiveProvisionTemplateDataQuery(baseOptions: Apollo.QueryHookOptions<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>(DispositiveProvisionTemplateDataDocument, withFetchPolicyContext(options));
      }
export function useDispositiveProvisionTemplateDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>(DispositiveProvisionTemplateDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositiveProvisionTemplateDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>(DispositiveProvisionTemplateDataDocument, withFetchPolicyContext(options));
        }
export type DispositiveProvisionTemplateDataQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateDataQuery>;
export type DispositiveProvisionTemplateDataLazyQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateDataLazyQuery>;
export type DispositiveProvisionTemplateDataSuspenseQueryHookResult = ReturnType<typeof useDispositiveProvisionTemplateDataSuspenseQuery>;
export type DispositiveProvisionTemplateDataQueryResult = Apollo.QueryResult<DispositiveProvisionTemplateDataQuery, DispositiveProvisionTemplateDataQueryVariables>;